import request from '@/axios/index'

/** member §1.1 — 认证 */
export function memberAuthLogin(data) {
  return request({ url: '/member/auth/login', method: 'post', data })
}

export function memberAuthSmsLogin(data) {
  return request({ url: '/member/auth/sms-login', method: 'post', data })
}

export function memberAuthLogout() {
  return request({ url: '/member/auth/logout', method: 'post' })
}

export function memberAuthRefreshToken(refreshToken) {
  return request({
    url: '/member/auth/refresh-token',
    method: 'post',
    params: { refreshToken },
  })
}

export function memberAuthSendSmsCode(data) {
  return request({ url: '/member/auth/send-sms-code', method: 'post', data })
}

export function memberAuthValidateSmsCode(data) {
  return request({ url: '/member/auth/validate-sms-code', method: 'post', data })
}

/** member §1.1.2 — 用户 */
export function memberUserGet() {
  return request({ url: '/member/user/get', method: 'get', skipAuthRedirect: true })
}

export function memberUserUpdate(data) {
  return request({ url: '/member/user/update', method: 'put', data })
}

export function memberUserUpdateMobile(data) {
  return request({ url: '/member/user/update-mobile', method: 'put', data })
}

export function memberUserUpdatePassword(data) {
  return request({ url: '/member/user/update-password', method: 'put', data })
}

export function memberUserResetPassword(data) {
  return request({ url: '/member/user/reset-password', method: 'put', data })
}

/** system 字典数据（按字典类型查询） */
export function systemDictDataType(params) {
  return request({ url: '/system/dict-data/type', method: 'get', params })
}

/** §7.1 门户首页 */
export function epolicyPortalHome() {
  return request({ url: '/epolicy/portal/home', method: 'get' })
}

export function epolicyPortalHotKeywords() {
  return request({ url: '/epolicy/portal/hot-keywords', method: 'get' })
}

/** §7.2 地区与字典 */
export function epolicyAreaProvinces() {
  return request({ url: '/epolicy/area/provinces', method: 'get' })
}

export function epolicyRegionTree(params) {
  return request({ url: '/epolicy/region/tree', method: 'get', params })
}

export function epolicyAreaTree(params) {
  return request({ url: '/epolicy/area/tree', method: 'get', params })
}

export function epolicyDictIndustryList(params) {
  return request({ url: '/epolicy/dict/industry/list', method: 'get', params })
}

export function epolicyDictIndustryCategories() {
  return request({ url: '/epolicy/dict/industry/categories', method: 'get' })
}

export function epolicyDictIndustryTree() {
  return request({ url: '/epolicy/dict/industry/tree', method: 'get' })
}

export function epolicyDictFieldList(params) {
  return request({ url: '/epolicy/dict/field/list', method: 'get', params })
}

export function epolicyDictDirectionList(params) {
  return request({ url: '/epolicy/dict/direction/list', method: 'get', params })
}

export function epolicyDictPolicyTypeList(params) {
  return request({ url: '/epolicy/dict/policy-type/list', method: 'get', params })
}

export function epolicyDictBusinessStatusList() {
  return request({ url: '/epolicy/dict/enterprise/business-status/list', method: 'get' })
}

export function epolicyDictEnterpriseTypeList() {
  return request({ url: '/epolicy/dict/enterprise/enterprise-type/list', method: 'get' })
}

export function epolicyVipProductList() {
  return request({ url: '/epolicy/product/vip/list', method: 'get' })
}

/** §7.3 政策 */
export function epolicyPolicyPage(params) {
  return request({ url: '/epolicy/policy/page', method: 'get', params })
}

export function epolicyPolicyGet(params) {
  return request({ url: '/epolicy/policy/get', method: 'get', params })
}

export function epolicyPolicyAttachmentList(params) {
  return request({ url: '/epolicy/policy/attachment/list', method: 'get', params })
}

export function epolicyPolicyIncrementClick(data) {
  return request({ url: '/epolicy/policy/increment-click', method: 'post', data })
}

/** §7.4 解读 */
export function epolicyInterpretationPage(params) {
  return request({ url: '/epolicy/interpretation/page', method: 'get', params })
}

export function epolicyInterpretationFilterOptions() {
  return request({ url: '/epolicy/interpretation/filter-options', method: 'get' })
}

export function epolicyInterpretationGet(params) {
  return request({ url: '/epolicy/interpretation/get', method: 'get', params })
}

export function epolicyInterpretationIncrementView(params) {
  return request({
    url: '/epolicy/interpretation/increment-view',
    method: 'post',
    params,
  })
}

export function epolicyInterpretationHotList(params) {
  return request({ url: '/epolicy/interpretation/hot-list', method: 'get', params })
}

/** §7.5 项目 */
export function epolicyProjectPage(params) {
  return request({ url: '/epolicy/project/page', method: 'get', params })
}

export function epolicyProjectGet(params) {
  return request({ url: '/epolicy/project/get', method: 'get', params })
}

export function epolicyProjectRelatedPolicies(params) {
  return request({ url: '/epolicy/project/related-policies', method: 'get', params })
}

/** §7.6 公示（历史 match 企业名单） */
export function epolicyPublicityPage(params) {
  return request({ url: '/epolicy/publicity/page', method: 'get', params })
}

export function epolicyPublicityFieldInfo(params) {
  return request({ url: '/epolicy/publicity/field-info', method: 'get', params })
}

/** 结果公示（结构化公示主表） */
export function epolicyResultPublicityPage(params) {
  return request({ url: '/epolicy/result-publicity/page', method: 'get', params })
}

export function epolicyResultPublicityGet(params) {
  return request({ url: '/epolicy/result-publicity/get', method: 'get', params })
}

/** §7.7 企业档案 */
export function epolicyEnterpriseProfile(params) {
  return request({ url: '/epolicy/enterprise/profile', method: 'get', params })
}

export function epolicyEnterpriseSearch(params) {
  return request({ url: '/epolicy/enterprise/search', method: 'get', params })
}

export function epolicyEnterpriseProfiles() {
  return request({ url: '/epolicy/enterprise/profiles', method: 'get' })
}

export function epolicyEnterpriseQualificationOptions() {
  return request({ url: '/epolicy/enterprise/qualification-options', method: 'get' })
}

export function epolicyEnterpriseBasicSave(data) {
  return request({ url: '/epolicy/enterprise/basic', method: 'put', data })
}

export function epolicyEnterpriseQualificationsSave(data) {
  return request({ url: '/epolicy/enterprise/qualifications', method: 'put', data })
}

export function epolicyEnterpriseFinancialsSave(data) {
  return request({ url: '/epolicy/enterprise/financials', method: 'put', data })
}

export function epolicyEnterpriseJudicialSave(data) {
  return request({ url: '/epolicy/enterprise/judicial', method: 'put', data })
}

export function epolicyEnterpriseSubmit(params) {
  return request({ url: '/epolicy/enterprise/submit', method: 'post', params })
}

export function epolicyEnterpriseSwitch(enterpriseId) {
  return request({ url: '/epolicy/enterprise/switch', method: 'post', params: { enterpriseId } })
}

export function epolicyEnterpriseDelete(enterpriseId) {
  return request({ url: '/epolicy/enterprise/delete', method: 'delete', params: { enterpriseId } })
}

/** §7.8 精准匹配 */
export function epolicyMatchSummary() {
  return request({ url: '/epolicy/match/summary', method: 'get' })
}

export function epolicyMatchPolicyPage(params) {
  return request({ url: '/epolicy/match/policy/page', method: 'get', params })
}

export function epolicyMatchRematch() {
  return request({
    url: '/epolicy/match/rematch',
    method: 'post',
    skipLoading: true,
  })
}

export function epolicyMatchRematchStatus(params) {
  return request({
    url: '/epolicy/match/rematch/status',
    method: 'get',
    params,
    skipLoading: true,
    // App 全局 resume 会探测进度；未绑企业等业务错误勿弹全局 Toast
    skipErrorMessage: true,
  })
}

export function epolicyMatchRematchCancel(params) {
  return request({
    url: '/epolicy/match/rematch/cancel',
    method: 'post',
    params,
    skipLoading: true,
  })
}

/** §7.9 申报服务 */
export function epolicyDeclarationCategories() {
  return request({ url: '/epolicy/declaration-service/categories', method: 'get' })
}

export function epolicyConsultationSubmit(data) {
  return request({ url: '/epolicy/consultation/submit', method: 'post', data })
}

export function epolicyDeclarationTemplatePage(params) {
  return request({ url: '/epolicy/declaration-service/template/page', method: 'get', params })
}

export function epolicyDeclarationTemplateFilterOptions() {
  return request({ url: '/epolicy/declaration-service/template/filter-options', method: 'get' })
}

/** §7.10 订阅管理 */
export function epolicySubscriptionConfig() {
  return request({ url: '/epolicy/subscription/config', method: 'get' })
}

export function epolicySubscriptionSave(data) {
  return request({ url: '/epolicy/subscription/save', method: 'put', data })
}

/** §7.11 发票 */
export function epolicyInvoiceProfileList() {
  return request({ url: '/epolicy/invoice/profile/list', method: 'get' })
}

export function epolicyInvoiceProfileSave(data) {
  return request({ url: '/epolicy/invoice/profile/save', method: 'post', data })
}

export function epolicyInvoiceApply(data) {
  return request({ url: '/epolicy/invoice/apply', method: 'post', data })
}

export function epolicyInvoiceInvoiceableOrders() {
  return request({ url: '/epolicy/invoice/invoiceable-orders', method: 'get' })
}

export function epolicyInvoicePage(params) {
  return request({ url: '/epolicy/invoice/page', method: 'get', params })
}

/** §7.12 收藏 */
export function epolicyFavoritePage(params) {
  return request({ url: '/epolicy/favorite/page', method: 'get', params })
}

export function epolicyFavoriteCreate(data) {
  return request({ url: '/epolicy/favorite/create', method: 'post', data })
}

export function epolicyFavoriteDelete(params) {
  return request({ url: '/epolicy/favorite/delete', method: 'delete', params })
}

/** §7.10 文件存储 */
export function infraFileUpload(formData) {
  return request({
    url: '/infra/file/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export function infraFilePresignedUrl(params) {
  return request({ url: '/infra/file/presigned-url', method: 'get', params })
}

export function infraFileCreate(data) {
  return request({ url: '/infra/file/create', method: 'post', data })
}

/** §7.13 订阅 */
export function epolicySubscriptionGet() {
  return request({ url: '/epolicy/subscription/get', method: 'get' })
}

export function epolicySubscriptionOrderPage(params) {
  return request({ url: '/epolicy/subscription/order/page', method: 'get', params })
}

export function epolicySubscriptionOrderStatus(params) {
  return request({ url: '/epolicy/subscription/order-status', method: 'get', params })
}

export function epolicySubscriptionCreateOrder(data) {
  return request({ url: '/epolicy/subscription/create-order', method: 'post', data })
}

export function epolicySubscriptionUpgradePrice(params) {
  return request({ url: '/epolicy/subscription/upgrade-price', method: 'get', params })
}

export function epolicySubscriptionCancel() {
  return request({ url: '/epolicy/subscription/cancel', method: 'post' })
}

/** 兑换中心 — 激活码兑换（错误由页面弹窗展示，不走全局 toast） */
export function epolicyActivationRedeem(data) {
  return request({ url: '/epolicy/activation/redeem', method: 'post', data, skipErrorMessage: true })
}

/** §7.14 产品权益 */
export function epolicyEntitlementGet() {
  return request({ url: '/epolicy/entitlement/get', method: 'get', skipAuthRedirect: true })
}

/** AI 助手 · 智能体货架（匿名可浏览，401 不强制跳登录） */
export function epolicyAiAgentsList() {
  return request({ url: '/epolicy/ai-agents/list', method: 'get', skipAuthRedirect: true })
}

export function epolicyAiAgentsGet(params) {
  return request({ url: '/epolicy/ai-agents/get', method: 'get', params, skipAuthRedirect: true })
}

/** AI 助手 · 申报报告 */
export function epolicyAiReportsPage(params) {
  return request({ url: '/epolicy/ai-reports/page', method: 'get', params })
}

export function epolicyAiReportsCreate(data) {
  return request({ url: '/epolicy/ai-reports/create', method: 'post', data })
}

export function epolicyAiReportsGet(params) {
  return request({ url: '/epolicy/ai-reports/get', method: 'get', params })
}

export function epolicyAiReportsUpdate(id, data) {
  return request({ url: `/epolicy/ai-reports/${id}`, method: 'put', data })
}

export function epolicyAiReportsSaveChapter(id, chapterId, data) {
  return request({ url: `/epolicy/ai-reports/${id}/chapters/${chapterId}`, method: 'put', data })
}

export function epolicyAiReportsOutline(id) {
  return request({ url: `/epolicy/ai-reports/${id}/outline`, method: 'post' })
}

export function epolicyAiReportsOutlineSelect(id, data) {
  return request({ url: `/epolicy/ai-reports/${id}/outline/select`, method: 'put', data })
}

export function epolicyAiReportsGenerateStart(id) {
  return request({ url: `/epolicy/ai-reports/${id}/generate/start`, method: 'post' })
}

export function epolicyAiReportsGenerateStatus(id) {
  return request({ url: `/epolicy/ai-reports/${id}/generate/status`, method: 'get' })
}

export function epolicyAiReportsRegenerateChapter(id, chapterId) {
  return request({ url: `/epolicy/ai-reports/${id}/chapters/${chapterId}/regenerate`, method: 'post' })
}

export function epolicyAiReportsParagraphAiEdit(id, data) {
  return request({ url: `/epolicy/ai-reports/${id}/paragraph-ai-edit`, method: 'post', data })
}

export function epolicyAiReportsExport(id) {
  return request({ url: `/epolicy/ai-reports/${id}/export`, method: 'post' })
}

export function epolicyAiReportsPublish(id) {
  return request({ url: `/epolicy/ai-reports/${id}/publish`, method: 'post' })
}

export function epolicyAiReportsDownload(id) {
  return request({ url: `/epolicy/ai-reports/${id}/download`, method: 'get' })
}

export function epolicyAiReportsVersions(id) {
  return request({ url: `/epolicy/ai-reports/${id}/versions`, method: 'get' })
}

export function epolicyAiReportsDelete(id) {
  return request({ url: `/epolicy/ai-reports/${id}`, method: 'delete' })
}
